import { logout } from "../api/portal";
import useAuthentication from "./useAuthentication";

/** Hook that returns logout function. */
const useLogout = () => {
  const { setAuthenticationContextValue } = useAuthentication();

  const handleLogout = () => {
    logout().then(() => {
      setAuthenticationContextValue({
        isLoadingLogin: false,
        isAuthCompleted: false,
        shouldInitializeUserLoad: false,
        isLoadingAdditionalAccountData: false,
        hasInitialUserLoadFailed: null,
        isLoadingMainAccountData: false,
        authFailMessage: "",
        user: undefined,
        webmaps: undefined,
      });
    });
  };

  return handleLogout;
};

export default useLogout;
